<template>
  <span v-if="notice_status!=null">
    <el-tooltip class="item" effect="dark" :content="noticeStatusText" placement="top-start">
     <i  class="el-icon-message" :class="noticeClass"></i>
     </el-tooltip>
  </span>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Invoice-notice-status',
	props: {
    notice_status : {
      type : Object,
      require : true
    }
	},
  data() {
    return {
    };
  },components: {

  },
	methods: {

	},
	computed: {
    noticeStatusText(){
      return this.$i18n.t('invoices.notice_statuses.' + this.notice_status.code);
    },
    noticeClass(){
      let styleClass="primary-text";
      if(this.notice_status==null){
        styleClass = "secondary-text"
      }else if(this.notice_status.code=='SENT'){
        styleClass = "warning-text"
      }else if(this.notice_status.code=='DELIVERED'){
        styleClass = "accent-text"
      }else if(this.notice_status.code=='OPENED'){
        styleClass = "success-text"
      }else if(this.notice_status.code=='BOUNCED'){
        styleClass = "danger-text"
      }else if(this.notice_status.code=='HARD_BOUNCED'){
        styleClass = "danger-text"
      }
      return styleClass;
    },
	}
}
</script>
